import React from 'react'

const SvgPetOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.498 9.548c.138.115.264.246.374.39l4.602 6c.828 1.078.66 2.651-.374 3.514a2.337 2.337 0 01-1.498.548H7.398C6.074 20 5 18.88 5 17.5c0-.568.185-1.12.525-1.562l4.603-6c.827-1.078 2.336-1.253 3.37-.39zm-1.784 1.608l-4.602 5.999A.57.57 0 007 17.5c0 .294.197.5.398.5h9.204c.074 0 .15-.028.217-.084.207-.173.245-.53.069-.761l-4.603-6a.455.455 0 00-.068-.071c-.158-.132-.365-.108-.503.072zM19.5 8a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-15 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm11-5a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-7 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5z'
    />
  </svg>
)

export default SvgPetOutline
